// src/pages/Multilingual.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import aboutSec1 from '../assets/img/core-img/multilingual-img.jpg';
import aboutSec2 from '../assets/img/core-img/about-sec2.jpg';



export default function Multilingual() {
  useEffect(() => {
    const $ = window.$;



    // — FAQ accordion binding & initial open state —
    if ($) {
      const $dts = $('.info-faq-area dt');
      $dts.removeClass('active').next('dd').hide();
      const $first = $dts.first();
      $first.addClass('active').next('dd').show();

      $dts.off('click').on('click', function() {
        const $dt = $(this);
        $dt.toggleClass('active')
           .next('dd').stop(true, true).slideToggle(300);
        $dt.siblings('dt').removeClass('active')
           .next('dd').stop(true, true).slideUp(300);
      });
    }

    // — Re-init WOW.js (for fadeInUp animations) —
    if (window.WOW) new window.WOW().init();
  }, []);

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcumb-area clearfix auto-init">
        <div className="breadcumb-content">
          <div className="container h-100">
            <div className="row h-100 align-items-center">
              <div className="col-12">
                <nav aria-label="breadcrumb" className="breadcumb--con text-center">
                  <h2 className="w-text title wow fadeInUp" data-wow-delay="0.2s">Multilingual</h2>
                  <ol className="breadcrumb justify-content-center wow fadeInUp" data-wow-delay="0.4s">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Multilingual</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Multilingual Services Area */}
      <section className="about-us-area section-padding-100 relative" id="multilingual">
        <div className="container">
          <div className="row align-items-center">
            {/* Text */}
            <div className="col-12 col-lg-6 col-md-12">
              <div className="who-we-contant">
                <div className="promo-section">
                  <h3 className="special-head">Multilingual Solutions</h3>
                </div>
                <h4 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Breaking Language Barriers Worldwide</h4>
                <p className="fadeInUp" data-wow-delay="0.4s">
                  <strong>We specialize in Indic languages and global rare languages.</strong> Ardent Translations
                  provides comprehensive multilingual services across diverse linguistic families, enabling
                  businesses to communicate effectively with underserved communities and niche markets through
                  expert translation, localization, and cultural adaptation.
                </p>
                <p className="fadeInUp" data-wow-delay="0.5s">
                  Our expertise in Indic languages includes Hindi, Tamil, Telugu, Marathi, Gujarati, Bengali,
                  Punjabi, Kannada, Malayalam, Assamese, and numerous regional dialects. We also excel in
                  global rare languages such as Dzongkha, Wolof, Lingala, Xhosa, and many indigenous languages,
                  ensuring authentic communication where others cannot reach.
                </p>
              
              </div>
            </div>
            {/* Image */}
            <div className="col-12 col-lg-6 col-md-12 no-padding-left">
              <div className="welcome-meter about-sec-wrapper wow fadeInUp mt-s" data-wow-delay="0.4s">
                <img
                  src={aboutSec1}
                  className="about-i"
                  alt="Multilingual services"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

                   {/* Contact CTA Area */}
             <div className="contact_us_area section-padding-0-0" id="contact">
               <div className="container">
                 <div className="call-us-sec v2">
                   <div className="row align-items-center">
                     <div className="col-12 col-lg-9">
                       <h3 className="w-text fadeInUp" data-wow-delay="0.3s">Get Your Custom Quote</h3>
                       <h2 className="bold w-text mb-0">Contact us for any translation inquiries</h2>
                     </div>
                     <div className="col-12 col-lg-3 right-on-lg">
                       <Link className="btn info-btn more-btn fadeInUp mt-s" data-wow-delay="0.6s" to="/contact-us">Contact us</Link>
                     </div>
                   </div>
                 </div>
               </div>
             </div>

      {/* Languages We Support */}
      <section className="languages-area section-padding-100 relative">
        <div className="container">
          <div className="section-heading text-center">
            <span>Our Specialization</span>
            <h2 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Indic Languages & Global Rare Languages</h2>
            <p className="fadeInUp" data-wow-delay="0.4s">
              We specialize in Indic languages and global rare languages, providing expert translation
              services for underserved linguistic communities worldwide.
            </p>
          </div>

          <div className="languages-grid">
            <div className="row">
              {[
                'HINDI', 'SADRI', 'KANNADA', 'MALAGASY', 'MARATHI', 'MEWARI', 'TAMIL', 'MERWARI',
                'TELUGU', 'SHONA', 'ASSAMESE', 'IGBO', 'GUJARATI', 'WAGDI', 'MALAYALAM', 'SHEKHAWATI',
                'PUNJABI', 'MARWARI', 'URDU', 'VARHADI-NAGPURI', 'MIZO', 'KURUKH', 'DZONGKHA', 'TSONGA',
                'NAGAMESE', 'OROMO', 'RAJASTHANI', 'KUMAONI', 'BODO', 'NORTHERN GONDI', 'DOGRI', 'DHIVEHI',
                'MINA', 'VENDA', 'HARYANVI', 'LINGALA', 'WOLOF', 'XHOSA', 'KINYARWANDA', 'TONGA'
              ].map((lang, i) => (
                <div className="col-lg-3 col-md-4 col-sm-6 col-6" key={i}>
                  <div className="language-item wow fadeInUp" data-wow-delay={`${0.1 + (i * 0.05)}s`}>
                    <div className="language-card">
                      <div className="language-icon">
                        <i className="fa fa-globe" aria-hidden="true"></i>
                      </div>
                      <h6 className="language-name">{lang}</h6>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .languages-area {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .languages-grid {
          margin-top: 50px;
        }

        .language-item {
          margin-bottom: 30px;
          padding: 0 10px;
        }

        .language-card {
          background: #fff;
          border-radius: 15px;
          padding: 25px 15px;
          text-align: center;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          border: 2px solid transparent;
          height: 120px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .language-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.15);
          border-color: #007bff;
        }

        .language-icon {
          font-size: 24px;
          color: #007bff;
          margin-bottom: 10px;
        }

        .language-name {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          margin: 0;
          line-height: 1.2;
        }



        @media (max-width: 768px) {
          .language-card {
            padding: 20px 10px;
            height: 100px;
          }

          .language-icon {
            font-size: 20px;
            margin-bottom: 8px;
          }

          .language-name {
            font-size: 12px;
          }
        }
      `}</style>


      {/* FAQ Section */}
      <div className="faq-timeline-area section-padding-100" id="faq">
        <div className="container">
          <div className="section-heading text-center">
            <span>Multilingual Questions</span>
            <h2 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Multilingual FAQs</h2>
            <p className="fadeInUp" data-wow-delay="0.4s">
              Common questions about our multilingual translation and localization services.
            </p>
          </div>
          <div className="row align-items-center">
            {/* Q&A */}
            <div className="col-12 col-lg-6 offset-lg-0 col-md-8 offset-md-2 col-sm-10 offset-sm-1">
              <div className="info-faq-area mt-s">
                <dl style={{ marginBottom: 0 }}>
                  <dt className="wave fadeInUp" data-wow-delay="0.2s">How many languages do you support?</dt>
                  <dd className="fadeInUp" data-wow-delay="0.3s">
                    <p>We specialize in Indic languages and global rare languages, providing translation services for over 40 specialized languages including regional dialects and indigenous languages.</p>
                  </dd>

                  <dt className="wave fadeInUp" data-wow-delay="0.3s">Do you handle multiple language projects simultaneously?</dt>
                  <dd className="fadeInUp" data-wow-delay="0.4s">
                    <p>Yes, we can manage complex multilingual projects across multiple languages with coordinated timelines, especially for Indic and rare language combinations.</p>
                  </dd>

                  <dt className="wave fadeInUp" data-wow-delay="0.4s">What industries do you serve for multilingual content?</dt>
                  <dd className="fadeInUp" data-wow-delay="0.5s">
                    <p>We serve all major industries including legal, medical, technical, marketing, e-commerce, and manufacturing sectors, with special expertise in underserved linguistic communities.</p>
                  </dd>

                  <dt className="wave fadeInUp" data-wow-delay="0.5s">Can you maintain consistency across multiple languages?</dt>
                  <dd className="fadeInUp" data-wow-delay="0.6s">
                    <p>We use translation memory and terminology management to ensure consistency across all language versions, with specialized glossaries for Indic and rare languages.</p>
                  </dd>
                </dl>
              </div>
            </div>
            {/* FAQ Image */}
            <div className="col-12 col-lg-6">
              <div className="welcome-meter about-sec-wrapper wow fadeInUp" data-wow-delay="0.4s">
                <img src={aboutSec2} alt="Multilingual FAQ" />
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
}